export const breadcrumb = {
  title: 'Phone verification',
  trunk: {
    index: 'Settings & testing'
  }
};
